import React from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { ImageResizeOptions, ThumbnailImage } from 'wix-ui-tpa/cssVars';
import { ServiceDetailsGalleryItem } from '../../../../../components/DailyAgenda/viewModel/serviceDetailsViewModel/serviceDetailsViewModel';
import {
  DataHooks,
  GALLERY_IMAGE_SIZE,
  GALLERY_IMAGE_SIZE_MOBILE,
} from '../../constants';
import { classes } from './ServiceDetailsGallery.st.css';

export type ServiceDetailsGalleryProps = {
  items: ServiceDetailsGalleryItem[];
};

const ServiceDetailsGallery: React.FC<ServiceDetailsGalleryProps> = ({
  items,
}) => {
  const { isMobile } = useEnvironment();
  const size = isMobile ? GALLERY_IMAGE_SIZE_MOBILE : GALLERY_IMAGE_SIZE;

  return (
    <div className={classes.gallery} data-hook={DataHooks.Gallery}>
      {items.map((item, index) => (
        <ThumbnailImage
          key={`${item.relativeUri}-${index}`}
          data-hook={DataHooks.GalleryImage}
          className={classes.galleryImage}
          src={item.relativeUri}
          alt={item.altText ?? ''}
          resize={ImageResizeOptions.cover}
          width={size.width}
          height={size.height}
        />
      ))}
    </div>
  );
};

export default ServiceDetailsGallery;
